import {BaseError} from '@vdw/angular-component-library';

export class LoadRuntimeApplicationEnvironmentError extends BaseError {
  public constructor() {
    super('Something went terribly wrong and we could not load the application configuration, please retry a bit later or contact support.');
  }
}
